// CRA inlines REACT_APP_* at build time. Operators may set
// REACT_APP_BUILD_STAMP on the glass-shop Hosting bake. The shop CRA
// still has no login footer — DEMO WALK shows this identity.
// Three-host Live jobs / DEMO entry unify (#197). Shared with admin + PWA.
export const FALLBACK_BUILD_STAMP = 'glass-live-jobs-entry-unified-20260915';

export const BUILD_STAMP = process.env.REACT_APP_BUILD_STAMP || FALLBACK_BUILD_STAMP;

export const BUILD_STAMP_HINT = 'Hard refresh if the walk looks stale · Cmd/Ctrl+Shift+R';
